import Vue from 'vue';
import VueRouter from 'vue-router';

import { http } from '@/api';

import { localGuard } from './interceptors/localeGuard';
import { setSegment } from '@/helpers/domain';

Vue.use(VueRouter);

// meta
// disableLangSwitch - Disables lang switch button in header

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: {
      name: 'Candidate',
    },
  },
  {
    path: '/candidate',
    name: 'Candidate',
    component: () => import(/* webpackChunkName: "candidate" */ '@/Views/Candidate.vue'),
  },
  {
    path: '/candidate/franchise',
    name: 'CandidateFranchise',
    component: () => import(/* webpackChunkName: "candidate" */ '@/Views/Franchise.vue'),
    meta: {
      disableLangSwitch: true,
    },
  },
  {
    path: '/video-candidate/:id',
    name: 'VideoCandidate',
    component: () => import(/* webpackChunkName: "video-candidate'" */ '@/Views/VideoCandidate.vue'),
  },
  {
    path: '/security-candidate/:id',
    name: 'SecurityCandidate',
    component: () => import(/* webpackChunkName: "video-candidate'" */ '@/Views/SecurityCandidate.vue'),
  },
  {
    path: '/candidate/vacancy',
    name: 'Vacancy',
    component: () => import(/* webpackChunkName: "vacancy" */ '@/Views/Vacancy.vue'),
  },
  {
    path: '/candidate/self-reject/:id',
    name: 'SelfReject',
    component: () => import(/* webpackChunkName: "self-reject'" */ '@/Views/SelfReject.vue'),
  },
  {
    path: '/office',
    name: 'OfficeLanding',
    component: () => import(/* webpackChunkName: "self-reject'" */ '@/Views/OfficeLanding.vue'),
  },
  {
    path: '/survey/:id',
    name: 'SurveyLanding',
    component: () => import(/* webpackChunkName: "self-reject'" */ '@/Views/SurveyLanding.vue'),
  },
  {
    path: '/external-card/:id',
    name: 'ExternalCard',
    component: () => import(/* webpackChunkName: "self-reject'" */ '@/Views/ExternalCard.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const segment = setSegment();
  // eslint-disable-next-line no-param-reassign
  to.query.segment = to.query.segment || segment;

  if (to.query.t) {
    http.defaults.headers['X-Authorization'] = to.query.t;
    http.defaults.headers['X-Authorization-Candidate'] = to.query.t;
  } else {
    const token = JSON.parse(sessionStorage.getItem('candidateToken'))?.token || '';

    http.defaults.headers['X-Authorization'] = token;
    http.defaults.headers['X-Authorization-Candidate'] = token;
  }

  localGuard(to, from, next);
});

export default router;
